import { createContext, useContext, useReducer } from 'react';
import { jobTitleReducer, initialState } from './reducer';

const JobTitleContext = createContext();

export const JobTitleProvider = ({ children }) => {
    const [state, dispatch] = useReducer(jobTitleReducer, initialState);

    return <JobTitleContext.Provider value={[state, dispatch]}>{children}</JobTitleContext.Provider>;
};

export const useJobTitleContext = () => {
    const context = useContext(JobTitleContext);
    if (!context) {
        throw new Error('useJobTitleContext must be used within a JobTitleProvider');
    }
    return context;
};
